module.exports = __webpack_public_path__ + "img/create.f0a52cfd.svg";